import React, { Component, ReactElement } from 'react';
import Button, { ButtonStyles } from './Button';

interface PopUpModalProps {
    title?: string;
    bodyContent? : ReactElement;
    buttonText : string;
    onClose(): void;
    onSubmit(): void;
    componentDidMount(): void;
}

export default class PopUpModal extends Component<PopUpModalProps> {

    componentDidMount() {
        const { componentDidMount } = this.props;
        componentDidMount();
    }

    onCancel = (): void => {
        const { onClose } = this.props;
        onClose();
    }

    onContinue = (): void => {
        const { onSubmit } = this.props;
        onSubmit();
    }

    render(): ReactElement {
        const { title, bodyContent, buttonText } = this.props;
        return (
            <>
                <div id="infoModal" className="modal modal--show" style={{ display: 'block' }}>
                    <div className="modal-container modal--dialog-box">
                        <span tabIndex={0} className="tab-filler"></span>
                        <h2 className="modal-headline">{title}</h2>
                        <button className="btn-close icon-close" aria-label="Close" type="button" onClick={this.onCancel} />
                        <div className="modal-content">
                            <>{bodyContent}</>
                            <div className="modal--call-to-action-bar">
                                <Button btnStyle={ButtonStyles.RightGreenButton} onClick={this.onContinue} title={buttonText} />
                            </div>
                        </div>
                        <span tabIndex={0} className="tab-filler"></span>
                    </div>
                </div>
            </>
        );
    }
}